import { useState, useEffect } from 'react';
import api from '../../myApi';
import './Archive.css';
import '../ScheduleComponent/Schedule.css';
import Select from '../Select/Select.jsx'

function Archive()
{
    const [mode,     setMode]     = useState('group');
    const [groups,   setGroups]   = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [weeks,    setWeeks]    = useState([]);
    const [selected, setSelected] = useState('');
    const [week,     setWeek]     = useState('');
    const [data,     setData]     = useState(null);
    const [loading,  setLoading]  = useState(false);
    const [weeksLoading, setWeeksLoading] = useState(false);
    const [error,    setError]    = useState(null);

    // Загружаем списки групп и преподавателей при монтировании
    useEffect(() => {
        api.get('/Archive/Groups').then(r  => setGroups(r.data)).catch(() => {});
        api.get('/Archive/Teachers').then(r => setTeachers(r.data)).catch(() => {});
    }, []);

    // Сбрасываем всё при смене режима
    useEffect(() => {
        setSelected('');
        setWeeks([]);
        setWeek('');
        setData(null);
        setError(null);
    }, [mode]);

    // Загружаем недели когда выбрана группа/преподаватель
    useEffect(() => {
        if (!selected) {
            setWeeks([]);
            setWeek('');
            setData(null);
            return;
        }

        const endpoint = mode === 'group'
            ? `/Archive/Weeks/Group/${encodeURIComponent(selected)}`
            : `/Archive/Weeks/Teacher/${encodeURIComponent(selected)}`;

        setWeeksLoading(true);
        setWeeks([]);
        setWeek('');
        setData(null);

        api.get(endpoint)
            .then(r => setWeeks(r.data))
            .catch(() => setWeeks([]))
            .finally(() => setWeeksLoading(false));

    }, [selected, mode]);

    const handleSearch = async () => {
        if (!selected || !week) return;
        const [dateFrom, dateTo] = week.split('|');
        const endpoint = mode === 'group'
            ? `/Archive/Group/${encodeURIComponent(selected)}`
            : `/Archive/Teacher/${encodeURIComponent(selected)}`;

        setLoading(true);
        setError(null);
        setData(null);
        try {
            const res = await api.get(endpoint, { params: { dateFrom, dateTo } });
            setData(res.data);
        } catch {
            setError('Ошибка загрузки архива');
        } finally {
            setLoading(false);
        }
    };

    const formatWeek = (w) => {
        const from = new Date(w.week_start).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
        const to   = new Date(w.week_end).toLocaleDateString('ru-RU',   { day: 'numeric', month: 'long', year: 'numeric' });
        return `${from} — ${to}`;
    };

    const teacherOptions = teachers.map(t => ({ value: t.teacher,    label: t.teacher }));
    const groupOptions   = groups  .map(g => ({ value: g.group_name, label: g.group_name }));

    const weekOptions = weeks.map(w => ({
        value: `${w.week_start}|${w.week_end}`,
        label: formatWeek(w),
    }));

    return (
        <div className="schedule-container">

            {/* Фильтры */}
            <div className="archive-filters">

                <div className="edu-filter">
                    <button
                        className={`edu-filter__btn vo ${mode === 'group' ? 'active' : ''}`}
                        onClick={() => setMode('group')}
                    >
                        По группе
                    </button>
                    <button
                        className={`edu-filter__btn spo ${mode === 'teacher' ? 'active' : ''}`}
                        onClick={() => setMode('teacher')}
                    >
                        По преподавателю
                    </button>
                </div>
                
                <h2 class="teacher-schedule__title"> Архив расписания </h2>

                <div className="archive-filters__selects">

                    {/* Шаг 1 — выбор группы / преподавателя */}
                    <div className="archive-filters__step">
                        <label className="archive-filters__label">
                            {mode === 'group' ? '1. Выберите группу' : '1. Выберите преподавателя'}
                        </label>
                        <Select
                            key={mode}
                            value={selected}
                            onChange={setSelected}
                            options={mode === 'group' ? groupOptions : teacherOptions}
                            placeholder={
                                mode === 'group'
                                    ? '— Выберите группу —'
                                    : '— Выберите преподавателя —'
                            }
                        />
                    </div>

                    {/* Шаг 2 — выбор недели */}
                    <div className="archive-filters__step">
                        <label className="archive-filters__label">
                            2. Выберите неделю
                            {selected && weeks.length === 0 && !weeksLoading &&
                                <span className="archive-filters__hint"> — нет данных в архиве</span>
                            }
                        </label>
                        <Select
                            value={week}
                            onChange={setWeek}
                            options={weekOptions}
                            loading={weeksLoading}
                            disabled={!selected || weeksLoading || weeks.length === 0}
                            placeholder={
                                weeksLoading
                                    ? 'Загрузка...'
                                    : weeks.length === 0 && selected
                                        ? '— Нет доступных недель —'
                                        : '— Выберите неделю —'
                            }
                        />
                    </div>

                    <button
                        className="archive-filters__btn"
                        onClick={handleSearch}
                        disabled={!selected || !week || loading}
                    >
                        Показать
                    </button>
                </div>
            </div>

            {/* Состояния */}
            {loading && <div className="loading">Загрузка архива...</div>}
            {error   && <div className="error">{error}</div>}
            {data && data.length === 0 && (
                <div className="archive-empty">Данных за выбранный период нет</div>
            )}

            {/* Результат */}
            {data && data.map(entity => (
                <div key={entity.group_name ?? entity.teacher} className="group-schedule">

                    <div className="group-header">
                        <h1>{entity.group_name ?? entity.teacher}</h1>
                    </div>

                    <div className="days-grid">
                        {entity.days.map(day => (
                            <div key={day.date} className="day-container">

                                <div className="day-header">
                                    <h2>{day.day_week.toUpperCase()}</h2>
                                    <h3>{day.date}</h3>
                                </div>

                                <div className="pairs-container">
                                    {day.pairs.map(pair => (
                                        <div key={pair.pair} className="pair-container">

                                            <div className="pair-header">
                                                <div className="pair-number">{pair.pair} пара</div>
                                                <div className="pair-time">
                                                    {pair.time_start} - {pair.time_end}
                                                </div>
                                            </div>

                                            <div className="pair-details">
                                                <h5>{pair.subject}</h5>
                                                {mode === 'group'
                                                    ? <p className="teacher">Преподаватель: {pair.teacher}</p>
                                                    : <p className="teacher">Группа: {
                                                        pair.group_names
                                                            ? pair.group_names.join(', ')
                                                            : pair.group_name
                                                    }</p>
                                                }
                                                <div className="pair-meta">
                                                    <span className="pair-type">{pair.pair_type}</span>
                                                    <span className="classroom">Аудитория: {pair.class_room}</span>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>

                            </div>
                        ))}
                    </div>

                </div>
            ))}

        </div>
    );
}

export default Archive;